module.exports = __webpack_public_path__ + "static/media/join-room-icon.8b9b3134.svg";